import {AfterContentInit, Component, OnInit, OnDestroy, Input} from "@angular/core";
import { Message } from "primeng/components/common/api";

import { NgToastrService } from "./ng-toastr.service";
import { Subscription } from "rxjs";

@Component({
    selector: "ng-toastr",
    template: `<p-growl [(value)]="toastMsg" [life]="life" [ngClass]="{ multiline: multiline }"></p-growl>`,
    styleUrls: ["./ng-toastr.component.css"]
})
export class NgToastrComponent implements OnInit, OnDestroy, AfterContentInit {
    @Input() life = null;
    private toastMsg: Message[] = [];

    private subscription: Subscription;
    multiline = false;

    constructor(private toastrService: NgToastrService) {
        this.subscription = toastrService.getObserverSubject()
            .subscribe((msg: Message) => {
                this.multiline = !!(msg && msg.detail);
            });
            toastrService.getLifeObserverSubject().subscribe( (data: number) => {
                this.life = data;
            });
    }

    ngOnInit(): void {
        this.toastrService.subscribe(msg => this.toastMsg = msg);
    }

    ngAfterContentInit() { // Reset the life counter and get latest message if any
        this.life = this.toastrService.getLife();
        this.toastMsg = this.toastrService.getMessage();
    }

    ngOnDestroy() {
        try {
            this.subscription.unsubscribe();
        } catch (e) { }
    }
}
